import { post, postJson,imagePost } from '../axios'
const RESOURCE_BASE_PATH = '/members-api'


/***
 * 查询成长值计算规则接口
 * @param p
 */
export const getGrowRule = p => post(`${RESOURCE_BASE_PATH}/growRuleController/getGrowRule?scoresCardId=${p}`);

/***
 * 保存成长值计算规则接口
 * @param p
 */
export const saveGrowRule = p => postJson(`${RESOURCE_BASE_PATH}/growRuleController/saveGrowRule`, p);

// 根据会员体系ID查询详情
export const getDetailById = p => post(`${RESOURCE_BASE_PATH}/scoresCard/getDetailById`, p);